import { useState } from 'react'

import { OrganizationDto } from '../interfaces/OrganizationDto.ts'
import { customFetch } from '../utils/customFetch.ts'

import { makeUrlOrganization } from './connectionData.tsx'

const useOrganizationFetcher = () => {
  const [errorOrganization, setErrorOrganization] = useState<Error | null>(null)
  const [loadingOrganization, setLoadingOrganization] = useState<boolean>(false)

  const fetchOrganization = async (organizationId: string) => {
    setLoadingOrganization(true)

    try {
      const apiUrl = makeUrlOrganization(organizationId)
      const data = await customFetch<OrganizationDto>(apiUrl)
      setErrorOrganization(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorOrganization(err)
      } else {
        setErrorOrganization(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingOrganization(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorOrganization, loadingOrganization, fetchOrganization }
}

export default useOrganizationFetcher
